/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/16/22
 */

import React from "react";
import {Chip, colors, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import {Calendar} from "../interfaces/Global";
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import {useDispatch, useSelector} from "react-redux";
import {State} from "../state/store";
import {add, remove} from "../state/reducers/favorites";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAsterisk } from '@fortawesome/free-solid-svg-icons'

export interface CalendarHeaderProps {
	savedCalendar?: Calendar | null
	unsavedChanges: boolean
}

export default function CalendarHeader({ savedCalendar, unsavedChanges }: CalendarHeaderProps) {

	const dispatch = useDispatch();
	const user = useSelector((s:State) => s.user);
	const defaultCalendarId = useSelector((s:State) => s.defaultCalendarId);
	const stateCalendar = useSelector((s:State) => s.calendar);
	const isFavorite = useSelector((s:State) => s.favorites.some(f => f === savedCalendar?.id));

	return (
		<Stack direction={"row"} spacing={1} alignItems={"center"} sx={{ ml: 1 }}>
			{savedCalendar && savedCalendar.createdBy !== user?.id &&
			<Tooltip title={isFavorite ? "Remove from favorites" : "Add to favorites"}>
				<IconButton
					onClick={() => {
						dispatch( isFavorite ? remove(savedCalendar.id) : add(savedCalendar.id));
					}}
				>
					{isFavorite ? <StarIcon /> : <StarBorderIcon />}
				</IconButton>
			</Tooltip>}
			<Stack direction={"row"} spacing={1} alignItems={"center"}>
				{!!stateCalendar.id &&
				<Stack direction={"row"}>
					<Stack>[</Stack>
					<Stack>{stateCalendar.id}</Stack>
					{unsavedChanges &&
					<Stack sx={{ color: colors.red[900] }}>
						<Tooltip title={"Unsaved Changes"}>
							<Stack>
								<FontAwesomeIcon icon={faAsterisk} />
							</Stack>
						</Tooltip>
					</Stack>}
					<Stack>]</Stack>
				</Stack>}
				<Stack>
					<Typography variant={"h6"}>
						{stateCalendar.title}
					</Typography>
				</Stack>
				{defaultCalendarId === stateCalendar.id &&
				<Stack>
					<Tooltip title={"This is your default calendar"}>
						<Chip label="Default" size={"small"} />
					</Tooltip>
				</Stack>}
			</Stack>
		</Stack>
	);

}